import { isEmptyObject } from '~/utils/utils';
import Mock from '~/core/mock';
import { Crew, Doll, Item, LootBox, Permoflages, Vehicle, VehicleType } from '~/vortex';
import { WarmingUpCollections, items } from '@wg/wows-entities/const';
import wowsEntities from '@wg/wows-entities';

export function getSectionName(type: string) {
    switch (type) {
        case items.VEHICLES:
            return WarmingUpCollections.vehicles;
        case items.CREWS:
            return WarmingUpCollections.crews;
        case items.LOOTBOX:
            return WarmingUpCollections.lootbox;
        case items.ITEMS:
        case items.MULTI_BOOST:
        case items.CAMO_BOOST:
        case items.GLOBAL_BOOST:
            return WarmingUpCollections.items;
        case items.DOLLS:
            return WarmingUpCollections.dogTagComponents;
        case items.PERMOFLAGES:
            return WarmingUpCollections.items;
    }
}

class VortexDataManager {
    public getDataBySection(section: WarmingUpCollections): any {
        const data = wowsEntities.getWarmingUpCache().get(section)?.data;
        if (!data) {
            return Mock.getMockByType(section);
        }

        if (!Object.keys(data).length) {
            return Mock.getMockByType(section);
        }

        return data;
    }

    public getData(section: WarmingUpCollections, id: number, withoutMock = false) {
        const result = this.getDataBySection(section)?.[id];
        if (!withoutMock) {
            return result || Mock.getMockByType(section);
        }
        return result;
    }

    public getClass(name: string): Nullable<VehicleType> {
        const data = this.getDataBySection(WarmingUpCollections.vehicleTypes) as VehicleType[];
        if (!data || isEmptyObject(data)) {
            return null;
        }
        return data.find((item: VehicleType) => item.name == name);
    }

    public getItem(id: number): Item {
        return this.getData(WarmingUpCollections.items, id);
    }

    public getShip(id: number): Vehicle {
        return this.getData(WarmingUpCollections.vehicles, id);
    }

    public getCrew(id: number): Crew {
        return this.getData(WarmingUpCollections.crews, id);
    }

    public getDoll(id: number): Doll {
        return this.getData(WarmingUpCollections.dogTagComponents, id);
    }

    public getPermoflage(id: number): Permoflages {
        return this.getData(WarmingUpCollections.items, id);
    }

    public getLootbox(id: number): LootBox {
        return this.getData(WarmingUpCollections.lootbox, id);
    }
}

export const ManagerData = new VortexDataManager();
